// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteRouteImport } from './routes/sign-up/route'
import { Route as SignInRouteRouteImport } from './routes/sign-in/route'
import { Route as InviteRouteRouteImport } from './routes/invite/route'
import { Route as CreateRouteRouteImport } from './routes/create/route'
import { Route as MarketingRouteRouteImport } from './routes/_marketing/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as SelectOrgIndexRouteImport } from './routes/select-org/index'
import { Route as SignUpIndexRouteImport } from './routes/sign-up/index'
import { Route as SignUpSplatRouteImport } from './routes/sign-up/$'
import { Route as SignInIndexRouteImport } from './routes/sign-in/index'
import { Route as SignInSplatRouteImport } from './routes/sign-in/$'
import { Route as InviteAcceptRouteImport } from './routes/invite/accept'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as InviteGroupRouteRouteImport } from './routes/invite/group/route'
import { Route as CreateIndexRouteImport } from './routes/create/index'
import { Route as CreateSplatRouteImport } from './routes/create/$'
import { Route as MarketingIndexRouteImport } from './routes/_marketing/index'
import { Route as AuthenticatedAppRouteRouteImport } from './routes/_authenticated/app/route'
import { Route as InviteTokenSplatRouteImport } from './routes/invite/$token/$'
import { Route as InviteGroupTokenRouteImport } from './routes/invite/group/$token'
import { Route as AuthenticatedAppIndexRouteImport } from './routes/_authenticated/app/index'
import { Route as AuthenticatedAppOnboardingGroupAdminRouteImport } from './routes/_authenticated/app/onboarding-group-admin'
import { Route as AuthenticatedAppOnboardingRouteImport } from './routes/_authenticated/app/onboarding'
import { Route as AuthenticatedAppAnalyticsRouteImport } from './routes/_authenticated/app/analytics'
import { Route as AuthenticatedAppSettingsRouteRouteImport } from './routes/_authenticated/app/settings/route'
import { Route as AuthenticatedAppAdminRouteRouteImport } from './routes/_authenticated/app/admin/route'
import { Route as AuthenticatedAppNotificationsIndexRouteImport } from './routes/_authenticated/app/notifications/index'
import { Route as AuthenticatedAppGroupsIndexRouteImport } from './routes/_authenticated/app/groups/index'
import { Route as AuthenticatedAppEventsIndexRouteImport } from './routes/_authenticated/app/events/index'
import { Route as AuthenticatedAppProfileUserIdRouteImport } from './routes/_authenticated/app/profile/$userId'
import { Route as AuthenticatedAppNewslettersNewsletterIdRouteImport } from './routes/_authenticated/app/newsletters/$newsletterId'
import { Route as AuthenticatedAppGroupsNewRouteImport } from './routes/_authenticated/app/groups/new'
import { Route as AuthenticatedAppEventsCreateRouteImport } from './routes/_authenticated/app/events/create'
import { Route as AuthenticatedAppGroupsGroupIdRouteRouteImport } from './routes/_authenticated/app/groups/$groupId/route'
import { Route as AuthenticatedAppSettingsIndexRouteImport } from './routes/_authenticated/app/settings/index'
import { Route as AuthenticatedAppSettingsNotificationsRouteImport } from './routes/_authenticated/app/settings/notifications'
import { Route as AuthenticatedAppSettingsAccountRouteImport } from './routes/_authenticated/app/settings/account'
import { Route as AuthenticatedAppAdminIndexRouteImport } from './routes/_authenticated/app/admin/index'
import { Route as AuthenticatedAppAdminTagsRouteImport } from './routes/_authenticated/app/admin/tags'
import { Route as AuthenticatedAppAdminSetupRouteImport } from './routes/_authenticated/app/admin/setup'
import { Route as AuthenticatedAppAdminRolesRouteImport } from './routes/_authenticated/app/admin/roles'
import { Route as AuthenticatedAppAdminDataPrivacyRouteImport } from './routes/_authenticated/app/admin/data-privacy'
import { Route as AuthenticatedAppAdminCommunitiesRouteImport } from './routes/_authenticated/app/admin/communities'
import { Route as AuthenticatedAppAdminCommunicationRouteImport } from './routes/_authenticated/app/admin/communication'
import { Route as AuthenticatedAppGroupsGroupIdIndexRouteImport } from './routes/_authenticated/app/groups/$groupId/index'
import { Route as AuthenticatedAppGroupsGroupIdResourcesRouteImport } from './routes/_authenticated/app/groups/$groupId/resources'
import { Route as AuthenticatedAppGroupsGroupIdPostsRouteImport } from './routes/_authenticated/app/groups/$groupId/posts'
import { Route as AuthenticatedAppGroupsGroupIdMembersRouteImport } from './routes/_authenticated/app/groups/$groupId/members'
import { Route as AuthenticatedAppGroupsGroupIdEventsRouteImport } from './routes/_authenticated/app/groups/$groupId/events'
import { Route as AuthenticatedAppGroupsGroupIdAnalyticsRouteImport } from './routes/_authenticated/app/groups/$groupId/analytics'
import { Route as AuthenticatedAppGroupsGroupIdAdminRouteRouteImport } from './routes/_authenticated/app/groups/$groupId/admin/route'
import { Route as AuthenticatedAppGroupsGroupIdAdminIndexRouteImport } from './routes/_authenticated/app/groups/$groupId/admin/index'
import { Route as AuthenticatedAppGroupsGroupIdAdminMembersRouteImport } from './routes/_authenticated/app/groups/$groupId/admin/members'
import { Route as AuthenticatedAppGroupsGroupIdAdminDigestRouteImport } from './routes/_authenticated/app/groups/$groupId/admin/digest'

const SignUpRouteRoute = SignUpRouteRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const SignInRouteRoute = SignInRouteRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const InviteRouteRoute = InviteRouteRouteImport.update({
            id: '/invite',path: '/invite',getParentRoute: () => rootRouteImport
          })
const CreateRouteRoute = CreateRouteRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => rootRouteImport
          })
const MarketingRouteRoute = MarketingRouteRouteImport.update({
            id: '/_marketing',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const SelectOrgIndexRoute = SelectOrgIndexRouteImport.update({
            id: '/select-org/',path: '/select-org/',getParentRoute: () => rootRouteImport
          })
const SignUpIndexRoute = SignUpIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SignUpRouteRoute
          })
const SignUpSplatRoute = SignUpSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => SignUpRouteRoute
          })
const SignInIndexRoute = SignInIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SignInRouteRoute
          })
const SignInSplatRoute = SignInSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => SignInRouteRoute
          })
const InviteAcceptRoute = InviteAcceptRouteImport.update({
            id: '/accept',path: '/accept',getParentRoute: () => InviteRouteRoute
          })
const InviteTokenRoute = InviteTokenRouteImport.update({
            id: '/$token',path: '/$token',getParentRoute: () => InviteRouteRoute
          })
const InviteGroupRouteRoute = InviteGroupRouteRouteImport.update({
            id: '/group',path: '/group',getParentRoute: () => InviteRouteRoute
          })
const CreateIndexRoute = CreateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CreateRouteRoute
          })
const CreateSplatRoute = CreateSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => CreateRouteRoute
          })
const MarketingIndexRoute = MarketingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MarketingRouteRoute
          })
const AuthenticatedAppRouteRoute = AuthenticatedAppRouteRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => AuthenticatedRouteRoute
          })
const InviteTokenSplatRoute = InviteTokenSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => InviteTokenRoute
          })
const InviteGroupTokenRoute = InviteGroupTokenRouteImport.update({
            id: '/$token',path: '/$token',getParentRoute: () => InviteGroupRouteRoute
          })
const AuthenticatedAppIndexRoute = AuthenticatedAppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppOnboardingGroupAdminRoute = AuthenticatedAppOnboardingGroupAdminRouteImport.update({
            id: '/onboarding-group-admin',path: '/onboarding-group-admin',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppOnboardingRoute = AuthenticatedAppOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppAnalyticsRoute = AuthenticatedAppAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppSettingsRouteRoute = AuthenticatedAppSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppAdminRouteRoute = AuthenticatedAppAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppNotificationsIndexRoute = AuthenticatedAppNotificationsIndexRouteImport.update({
            id: '/notifications/',path: '/notifications/',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppGroupsIndexRoute = AuthenticatedAppGroupsIndexRouteImport.update({
            id: '/groups/',path: '/groups/',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppEventsIndexRoute = AuthenticatedAppEventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppProfileUserIdRoute = AuthenticatedAppProfileUserIdRouteImport.update({
            id: '/profile/$userId',path: '/profile/$userId',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppNewslettersNewsletterIdRoute = AuthenticatedAppNewslettersNewsletterIdRouteImport.update({
            id: '/newsletters/$newsletterId',path: '/newsletters/$newsletterId',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppGroupsNewRoute = AuthenticatedAppGroupsNewRouteImport.update({
            id: '/groups/new',path: '/groups/new',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppEventsCreateRoute = AuthenticatedAppEventsCreateRouteImport.update({
            id: '/events/create',path: '/events/create',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppGroupsGroupIdRouteRoute = AuthenticatedAppGroupsGroupIdRouteRouteImport.update({
            id: '/groups/$groupId',path: '/groups/$groupId',getParentRoute: () => AuthenticatedAppRouteRoute
          })
const AuthenticatedAppSettingsIndexRoute = AuthenticatedAppSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppSettingsRouteRoute
          })
const AuthenticatedAppSettingsNotificationsRoute = AuthenticatedAppSettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedAppSettingsRouteRoute
          })
const AuthenticatedAppSettingsAccountRoute = AuthenticatedAppSettingsAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedAppSettingsRouteRoute
          })
const AuthenticatedAppAdminIndexRoute = AuthenticatedAppAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppAdminRouteRoute
          })
const AuthenticatedAppAdminTagsRoute = AuthenticatedAppAdminTagsRouteImport.update({
            id: '/tags',path: '/tags',getParentRoute: () => AuthenticatedAppAdminRouteRoute
          })
const AuthenticatedAppAdminSetupRoute = AuthenticatedAppAdminSetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => AuthenticatedAppAdminRouteRoute
          })
const AuthenticatedAppAdminRolesRoute = AuthenticatedAppAdminRolesRouteImport.update({
            id: '/roles',path: '/roles',getParentRoute: () => AuthenticatedAppAdminRouteRoute
          })
const AuthenticatedAppAdminDataPrivacyRoute = AuthenticatedAppAdminDataPrivacyRouteImport.update({
            id: '/data-privacy',path: '/data-privacy',getParentRoute: () => AuthenticatedAppAdminRouteRoute
          })
const AuthenticatedAppAdminCommunitiesRoute = AuthenticatedAppAdminCommunitiesRouteImport.update({
            id: '/communities',path: '/communities',getParentRoute: () => AuthenticatedAppAdminRouteRoute
          })
const AuthenticatedAppAdminCommunicationRoute = AuthenticatedAppAdminCommunicationRouteImport.update({
            id: '/communication',path: '/communication',getParentRoute: () => AuthenticatedAppAdminRouteRoute
          })
const AuthenticatedAppGroupsGroupIdIndexRoute = AuthenticatedAppGroupsGroupIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppGroupsGroupIdRouteRoute
          })
const AuthenticatedAppGroupsGroupIdResourcesRoute = AuthenticatedAppGroupsGroupIdResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => AuthenticatedAppGroupsGroupIdRouteRoute
          })
const AuthenticatedAppGroupsGroupIdPostsRoute = AuthenticatedAppGroupsGroupIdPostsRouteImport.update({
            id: '/posts',path: '/posts',getParentRoute: () => AuthenticatedAppGroupsGroupIdRouteRoute
          })
const AuthenticatedAppGroupsGroupIdMembersRoute = AuthenticatedAppGroupsGroupIdMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => AuthenticatedAppGroupsGroupIdRouteRoute
          })
const AuthenticatedAppGroupsGroupIdEventsRoute = AuthenticatedAppGroupsGroupIdEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => AuthenticatedAppGroupsGroupIdRouteRoute
          })
const AuthenticatedAppGroupsGroupIdAnalyticsRoute = AuthenticatedAppGroupsGroupIdAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedAppGroupsGroupIdRouteRoute
          })
const AuthenticatedAppGroupsGroupIdAdminRouteRoute = AuthenticatedAppGroupsGroupIdAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedAppGroupsGroupIdRouteRoute
          })
const AuthenticatedAppGroupsGroupIdAdminIndexRoute = AuthenticatedAppGroupsGroupIdAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAppGroupsGroupIdAdminRouteRoute
          })
const AuthenticatedAppGroupsGroupIdAdminMembersRoute = AuthenticatedAppGroupsGroupIdAdminMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => AuthenticatedAppGroupsGroupIdAdminRouteRoute
          })
const AuthenticatedAppGroupsGroupIdAdminDigestRoute = AuthenticatedAppGroupsGroupIdAdminDigestRouteImport.update({
            id: '/digest',path: '/digest',getParentRoute: () => AuthenticatedAppGroupsGroupIdAdminRouteRoute
          })





const AuthenticatedAppAdminRouteRouteChildren = {
  AuthenticatedAppAdminCommunicationRoute: AuthenticatedAppAdminCommunicationRoute,AuthenticatedAppAdminCommunitiesRoute: AuthenticatedAppAdminCommunitiesRoute,AuthenticatedAppAdminDataPrivacyRoute: AuthenticatedAppAdminDataPrivacyRoute,AuthenticatedAppAdminRolesRoute: AuthenticatedAppAdminRolesRoute,AuthenticatedAppAdminSetupRoute: AuthenticatedAppAdminSetupRoute,AuthenticatedAppAdminTagsRoute: AuthenticatedAppAdminTagsRoute,AuthenticatedAppAdminIndexRoute: AuthenticatedAppAdminIndexRoute
}

const AuthenticatedAppAdminRouteRouteWithChildren = AuthenticatedAppAdminRouteRoute._addFileChildren(AuthenticatedAppAdminRouteRouteChildren)




const AuthenticatedAppSettingsRouteRouteChildren = {
  AuthenticatedAppSettingsAccountRoute: AuthenticatedAppSettingsAccountRoute,AuthenticatedAppSettingsNotificationsRoute: AuthenticatedAppSettingsNotificationsRoute,AuthenticatedAppSettingsIndexRoute: AuthenticatedAppSettingsIndexRoute
}

const AuthenticatedAppSettingsRouteRouteWithChildren = AuthenticatedAppSettingsRouteRoute._addFileChildren(AuthenticatedAppSettingsRouteRouteChildren)




const AuthenticatedAppGroupsGroupIdAdminRouteRouteChildren = {
  AuthenticatedAppGroupsGroupIdAdminDigestRoute: AuthenticatedAppGroupsGroupIdAdminDigestRoute,AuthenticatedAppGroupsGroupIdAdminMembersRoute: AuthenticatedAppGroupsGroupIdAdminMembersRoute,AuthenticatedAppGroupsGroupIdAdminIndexRoute: AuthenticatedAppGroupsGroupIdAdminIndexRoute
}

const AuthenticatedAppGroupsGroupIdAdminRouteRouteWithChildren = AuthenticatedAppGroupsGroupIdAdminRouteRoute._addFileChildren(AuthenticatedAppGroupsGroupIdAdminRouteRouteChildren)



const AuthenticatedAppGroupsGroupIdRouteRouteChildren = {
  AuthenticatedAppGroupsGroupIdAdminRouteRoute: AuthenticatedAppGroupsGroupIdAdminRouteRouteWithChildren,AuthenticatedAppGroupsGroupIdAnalyticsRoute: AuthenticatedAppGroupsGroupIdAnalyticsRoute,AuthenticatedAppGroupsGroupIdEventsRoute: AuthenticatedAppGroupsGroupIdEventsRoute,AuthenticatedAppGroupsGroupIdMembersRoute: AuthenticatedAppGroupsGroupIdMembersRoute,AuthenticatedAppGroupsGroupIdPostsRoute: AuthenticatedAppGroupsGroupIdPostsRoute,AuthenticatedAppGroupsGroupIdResourcesRoute: AuthenticatedAppGroupsGroupIdResourcesRoute,AuthenticatedAppGroupsGroupIdIndexRoute: AuthenticatedAppGroupsGroupIdIndexRoute
}

const AuthenticatedAppGroupsGroupIdRouteRouteWithChildren = AuthenticatedAppGroupsGroupIdRouteRoute._addFileChildren(AuthenticatedAppGroupsGroupIdRouteRouteChildren)



const AuthenticatedAppRouteRouteChildren = {
  AuthenticatedAppAdminRouteRoute: AuthenticatedAppAdminRouteRouteWithChildren,AuthenticatedAppSettingsRouteRoute: AuthenticatedAppSettingsRouteRouteWithChildren,AuthenticatedAppAnalyticsRoute: AuthenticatedAppAnalyticsRoute,AuthenticatedAppOnboardingRoute: AuthenticatedAppOnboardingRoute,AuthenticatedAppOnboardingGroupAdminRoute: AuthenticatedAppOnboardingGroupAdminRoute,AuthenticatedAppIndexRoute: AuthenticatedAppIndexRoute,AuthenticatedAppGroupsGroupIdRouteRoute: AuthenticatedAppGroupsGroupIdRouteRouteWithChildren,AuthenticatedAppEventsCreateRoute: AuthenticatedAppEventsCreateRoute,AuthenticatedAppGroupsNewRoute: AuthenticatedAppGroupsNewRoute,AuthenticatedAppNewslettersNewsletterIdRoute: AuthenticatedAppNewslettersNewsletterIdRoute,AuthenticatedAppProfileUserIdRoute: AuthenticatedAppProfileUserIdRoute,AuthenticatedAppEventsIndexRoute: AuthenticatedAppEventsIndexRoute,AuthenticatedAppGroupsIndexRoute: AuthenticatedAppGroupsIndexRoute,AuthenticatedAppNotificationsIndexRoute: AuthenticatedAppNotificationsIndexRoute
}

const AuthenticatedAppRouteRouteWithChildren = AuthenticatedAppRouteRoute._addFileChildren(AuthenticatedAppRouteRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAppRouteRoute: AuthenticatedAppRouteRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const MarketingRouteRouteChildren = {
  MarketingIndexRoute: MarketingIndexRoute
}

const MarketingRouteRouteWithChildren = MarketingRouteRoute._addFileChildren(MarketingRouteRouteChildren)




const CreateRouteRouteChildren = {
  CreateSplatRoute: CreateSplatRoute,CreateIndexRoute: CreateIndexRoute
}

const CreateRouteRouteWithChildren = CreateRouteRoute._addFileChildren(CreateRouteRouteChildren)




const InviteGroupRouteRouteChildren = {
  InviteGroupTokenRoute: InviteGroupTokenRoute
}

const InviteGroupRouteRouteWithChildren = InviteGroupRouteRoute._addFileChildren(InviteGroupRouteRouteChildren)




const InviteTokenRouteChildren = {
  InviteTokenSplatRoute: InviteTokenSplatRoute
}

const InviteTokenRouteWithChildren = InviteTokenRoute._addFileChildren(InviteTokenRouteChildren)



const InviteRouteRouteChildren = {
  InviteGroupRouteRoute: InviteGroupRouteRouteWithChildren,InviteTokenRoute: InviteTokenRouteWithChildren,InviteAcceptRoute: InviteAcceptRoute
}

const InviteRouteRouteWithChildren = InviteRouteRoute._addFileChildren(InviteRouteRouteChildren)




const SignInRouteRouteChildren = {
  SignInSplatRoute: SignInSplatRoute,SignInIndexRoute: SignInIndexRoute
}

const SignInRouteRouteWithChildren = SignInRouteRoute._addFileChildren(SignInRouteRouteChildren)




const SignUpRouteRouteChildren = {
  SignUpSplatRoute: SignUpSplatRoute,SignUpIndexRoute: SignUpIndexRoute
}

const SignUpRouteRouteWithChildren = SignUpRouteRoute._addFileChildren(SignUpRouteRouteChildren)

const rootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,MarketingRouteRoute: MarketingRouteRouteWithChildren,CreateRouteRoute: CreateRouteRouteWithChildren,InviteRouteRoute: InviteRouteRouteWithChildren,SignInRouteRoute: SignInRouteRouteWithChildren,SignUpRouteRoute: SignUpRouteRouteWithChildren,SelectOrgIndexRoute: SelectOrgIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)